export default __webpack_public_path__ + "static/about1-67a3d6fd1487ad356447b647fec905a5.jpg";